import React from 'react';
import RLogo from '../components/RLogo.js'


function HomePage() {
    return (
        <>
            <h2>Welcome to my portfolio site!</h2>
            <article>
                <div>
                    <RLogo/>
                </div>
                <p>With about ten years of experience in the logistics field, I began studies for a second bachelor's degree with the goal
                    to ultimately pivot to a career in computer programming. My lifelong interest in computers and programming as a hobbyist
                    has made it an easy and natural transition, and my near-term goal is to land a junior developer role with a good company
                    whose values align with my own.
                </p>

                <p>A number of web technologies and frameworks are used in the making of this site, ranging from the simple and foundational
                    to the specialized and contemporary:
                </p>

                <dl>
                    <dt><strong>HTML</strong></dt>
                    <dd>
                        <strong>HyperText Markup Language</strong> (HTML) is the bedrock upon which the entire web was and is built. First introduced
                        to the public in 1993, it is a standardized format to send and receive document requests between networked machines.
                        It is used to present the basic content of this site, such as text, article and paragraph sections, headings, etc, as well
                        as handle the aforementioned POST, GET, PUT, and DELETE requests.
                        </dd>

                    <dt><strong>CSS</strong></dt>
                    <dd>
                        A <strong>Cascading Style Sheet</strong> (CSS) is a formalized document containing a coding language that styles HTML elements
                    and allows web browsers to render a cleaner, more refined presentation of the basic information provided in those elements. CSS is
                    used within the context of this site to provide a consistent color palette and typography, organize the mixed media used within the 
                    overall web app, and maintain a consistenly positive user experience across of range of devices.
                    </dd>

                    <dt><strong>Node</strong></dt>
                    <dd> 
                        Styled simply as <strong>Node</strong>, Node.js is a server-side, open-source runtime environment used to execute
                    back-end JavaScript code outside of a web browser. It's libraries and execution are focused on event-driven, asynchronus 
                    programming across the major platoforms (Windows, Linux, Unix, macOS, etc.) to keep it lightweight. In this project, it performs the
                    back end work of processing requests and serving information for the front-end to present to you, the user.
                     </dd>

                    <dt><strong>Express</strong></dt>
                    <dd>
                        Similary styled as just <strong>Express</strong>, Express.js is a popular framework that simplifies common web app tasks
                    like GET, POST, DELETE, port routing, and data routing through the use of Application Programming Interfaces, or APIs. These are exactly
                    the tasks I'm using Express for with this project.
                    </dd>

                    <dt><strong>Javascript</strong></dt>
                    <dd>
                        Where HTML is the drawing, <strong>JavaScript</strong> is the animation. Arriving shortly after HTML in the early '90s, it allows web browsers
                    to execute dynamic behavior within statically-loaded HTML Document Objects. Javascript's fingerprints are all over this and every other site on the web
                    today, and it's utility as a bonafide programming language like Python, C/C++/C#, etc. has expanded greatly since it's original introduction.
                    </dd>

                    <dt><strong>DOM Manipulation</strong></dt>
                    <dd>
                        <strong>DOM Manipulation</strong> is the process JavaScript uses to create, read, update, delete, and edit information loaded into the browser
                    by an HTML document. In this project, it's used to present webpages that respond to user input and display changes dynamically.
                    </dd>

                    <dt><strong>Asynchronous Programming</strong></dt>
                    <dd>
                        <strong>Asynchronous programming</strong> is more of a concept than a concrete technology like the others on this page. Nevertheless, it is integral
                    to creating web pages the public will use willingly. Asynchronus programming entails the processing of multiple tasks concurrently to reduce bottlenecking, 
                    which is experienced by the user as reduced load times. It is essentially a form of multi-threading, and it shows up within the context of this
                    project mostly in the form of JavaScript await/promise syntax.
                    </dd>

                    <dt><strong>MongoDB</strong></dt>
                    <dd><strong>MongoDB</strong> is a non-SQL-based database management system that primarily uses JSON documents to store data. It's used on this site for 
                    CRUD (create, read, update, delete) operations.</dd>

                    <dt><strong>Mongoose</strong></dt>
                    <dd><strong>Mongoose</strong> is a JavaScript library which helps facilitate communication between the Node app functions and MongoDB. </dd>

                    <dt><strong>React</strong></dt>
                    <dd><strong>React </strong> is a popular JavaScript framework that modularizes the creation of pages and takes care of many low-level tasks declaratively. </dd>

                </dl>
            </article>
        </>
    );
}

export default HomePage;